import React from "react";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { globalLoadingCountState } from "../recoil/ui";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: saturate(140%) blur(1.5px);
`;

const Spinner = styled.div`
  width: 44px;
  height: 44px;
  border: 3px solid #1890ff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export default function GlobalLoadingOverlay() {
  const loadingCount = useRecoilValue(globalLoadingCountState);
  if (!loadingCount || loadingCount <= 0) return null;

  return (
    <Overlay>
      <Spinner />
    </Overlay>
  );
}
